import { useBetSliderStore } from '@stores/betSliderStore'
import { useConfigurationStore } from '@stores/configurationStore'
import { BetGroup, BetOptionItem } from 'game-ui-types'

export const isBetOptionItem = (option: number | BetOptionItem): option is BetOptionItem => {
    return typeof option === 'object'
}

export const isBetOptionItems = (options: number[] | BetOptionItem[]): options is BetOptionItem[] => {
    return typeof options[0] === 'object'
}

export const getBetValue = (option: number | BetOptionItem): number => {
    return isBetOptionItem(option) ? option.betAmount : option
}

export const groupBetsByGroup = (options: BetOptionItem[] | number[]): BetGroup | null => {
    if (!isBetOptionItems(options)) {
        return null
    }

    return options.reduce((dictionary, option) => {
        if (!dictionary[option.betGroupId]) {
            dictionary[option.betGroupId] = [] as BetOptionItem[]
        }

        dictionary[option.betGroupId].push(option)

        return dictionary
    }, {} as BetGroup)
}

export const useActiveBetOptions = (): number[] | BetOptionItem[] => {
    const betOptions = useConfigurationStore((state) => state.betOptions)
    const groupBetOptions = useBetSliderStore((state) => state.activeBetGroupBetOptions)

    return groupBetOptions ?? betOptions
}
